//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { PageUtils } from "./helpers/page-utils";
const _debounce = require('lodash.debounce');

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

let handleEscapeKey = null;

function openLightBox(lightbox) {
    document.body.dataset.lightboxOpen = 'true';
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();
    document.getElementById('siteHeader').dataset.visible = 'false';
    document.body.dataset.navVisible = 'false';

    handleEscapeKey = function (e) {
        if (e.key === 'Escape') {
            closeLightBox(lightbox);
        }
    };
    document.addEventListener('keydown', handleEscapeKey);

    setTimeout(() => { lightbox.dataset.visible = 'true'; }, 50);
}

function closeLightBox(lightbox) {
    document.body.dataset.lightboxOpen = 'false';
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();

    if (handleEscapeKey) {
        document.removeEventListener('keydown', handleEscapeKey);
        handleEscapeKey = null;
    }

    setTimeout(() => { lightbox.dataset.hidden = 'true'; }, 300);
}

window.addEventListener('load', () => {
    const swiperElementsPresent = !!document.querySelector('.swiper');

    const galleryPanel = document.querySelectorAll('.gallery-panel');
    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const testimonialFaderPanel = document.querySelectorAll('.testimonial-panel-fader');
    const teamPanel = document.querySelectorAll('.team-panel');

    if (swiperElementsPresent) {

        // START CARD PANEL SLIDER
        for (const panel of cardPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });
            }
        }
        // END CARD PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for (const panel of galleryPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="gallery-slider"]');

            if (swiperElement) {
                const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
                const swiperElementLightbox = panel.querySelector('.swiper[data-swiper-type="gallery-lightbox-slider"]');

                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="gallery-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="gallery-slider-${swiperIndex}"]`;

                let gallerySwiper;
                let galleryLightboxSwiper;

                function initSwipers() {
                    if (!gallerySwiper) {
                        gallerySwiper = new Swiper(swiperElement, {
                            loop: true,
                            loopedSlides: 10,
                            speed: 350,
                            direction: 'horizontal',
                            allowTouchMove: true,
                            resistanceRatio: 0,
                            autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                            slidesPerView: mobileSlidePerPage,
                            slidesPerGroup: 1,
                            spaceBetween: 24,
                            centeredSlides: false,
                            pagination: {
                                el: `[data-swiper-pagination="gallery-slider-${swiperIndex}"]`,
                                clickable: true,
                                renderBullet: function (index, className) {
                                    return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                },
                            },
                            navigation: { nextEl: nextEl, prevEl: prevEl },
                            breakpoints: {
                                640: { slidesPerView: mobileSlidePerPage, spaceBetween: 24 },
                                768: { slidesPerView: tabletSlidePerPage, spaceBetween: 24 },
                                1024: { slidesPerView: tabletSlidePerPage, spaceBetween: 32 },
                                1280: { slidesPerView: 3, spaceBetween: 32, centeredSlides: true },
                            },
                        });
                    }
                }

                if (!!lightbox && !!swiperElementLightbox) {
                    galleryLightboxSwiper = new Swiper(swiperElementLightbox, {
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                        loop: true,
                        speed: 750,
                        direction: 'horizontal',
                        allowTouchMove: true,
                        autoplay: autoplay ?
                            {
                                delay: 10000,
                                disableOnInteraction: false
                            } : false,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    });
                }

                initSwipers();

                let previousWindowWidth = window.innerWidth;

                const handleResize = _debounce(() => {
                    const currentWindowWidth = window.innerWidth;

                    const crossed1280Breakpoint = (
                        (previousWindowWidth >= 1280 && currentWindowWidth < 1280) ||
                        (previousWindowWidth < 1280 && currentWindowWidth >= 1280)
                    );

                    if (crossed1280Breakpoint) {
                        if (gallerySwiper) {
                            gallerySwiper.destroy(true, true);
                            gallerySwiper = null;
                        }
                    }

                    initSwipers();
                    previousWindowWidth = currentWindowWidth;
                }, 300);


                window.addEventListener("resize", handleResize);

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }
                }

                let syncing = false;

                if (galleryLightboxSwiper && gallerySwiper) {
                    galleryLightboxSwiper.on('slideChange', function () {
                        if (!syncing) {
                            syncing = true;
                            gallerySwiper.slideToLoop(galleryLightboxSwiper.realIndex, 0, false);
                            syncing = false;
                        }
                    });
                }

                swiperElement.addEventListener('click', (e) => {
                    const galleryThumbnail = e.target.closest('.gallery-panel-image');

                    if (galleryThumbnail) {
                        const slideIndex = parseInt(galleryThumbnail.dataset.slide);
                        syncing = true;

                        openLightBox(lightbox);

                        setTimeout(() => {
                            galleryLightboxSwiper.update(); // important for hidden Swipers
                            galleryLightboxSwiper.slideToLoop(slideIndex, 0);

                            syncing = false;
                        }, 50);
                    }
                });

            }
        }
        // END GALLERY PANEL SLIDER

        // START TESTIMONIAL PANEL FADER
        for (const panel of testimonialFaderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-fader"]');

            if (swiperElement) {
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-fader-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-fader-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    loop: true,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-fader-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 1,
                        },
                        1450: {
                            slidesPerView: 1,
                        },
                    },
                });
            }
        }
        // END TESTIMONIAL PANEL FADER

        // START TEAM PANEL SLIDER
        for (const panel of teamPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="team-slider"]');

            if (swiperElement) {
                const cardCount = parseInt(swiperElement.dataset.totalSlides, 10);
                const xsPerPage = cardCount > 1 ? 1.1 : 1;
                const smPerPage = cardCount > 2 ? 2.1 : 2;
                const mdPerPage = cardCount > 3 ? 3.1 : 3;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const destroySwiperDesktop = swiperElement.dataset.destroySwiperDesktop === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="team-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="team-slider-${swiperIndex}"]`;

                let teamMemberSwiper;

                function initSwipers() {
                    if (window.innerWidth >= 1280 && destroySwiperDesktop) {
                        if (teamMemberSwiper) {
                            teamMemberSwiper.destroy(true, true);
                            teamMemberSwiper = null;
                        }
                    } else {
                        if (!teamMemberSwiper) {
                            teamMemberSwiper = new Swiper(swiperElement, {
                                loop: false,
                                speed: 350,
                                direction: 'horizontal',
                                allowTouchMove: true,
                                resistanceRatio: 0,
                                autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                                slidesPerView: xsPerPage,
                                slidesPerGroup: 1,
                                spaceBetween: 24,
                                watchSlidesProgress: true,
                                pagination: {
                                    el: `[data-swiper-pagination="team-slider-${swiperIndex}"]`,
                                    clickable: true,
                                    renderBullet: function (index, className) {
                                        return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                    },
                                },
                                navigation: { nextEl: nextEl, prevEl: prevEl },
                                breakpoints: {
                                    480: { slidesPerView: smPerPage, spaceBetween: 24 },
                                    640: { slidesPerView: smPerPage, spaceBetween: 24 },
                                    768: { slidesPerView: mdPerPage, spaceBetween: 24 },
                                    1024: { slidesPerView: mdPerPage, spaceBetween: 32 },
                                    1280: { slidesPerView: 3, spaceBetween: 32 },
                                },
                            });
                        }
                    }
                }

                initSwipers();

                const handleResize = _debounce(() => {
                    initSwipers();
                }, 300);

                window.addEventListener("resize", handleResize);
            }
        }
        // END TEAM PANEL SLIDER

    }
});
